module.exports = __webpack_public_path__ + "static/zwartgoude-jurk-cbe01d7be5150bd07fd01e1e427ed00b.jpg";